import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import UnlockButton from './unlock/UnlockButton';
import { Box } from 'home/useBoxes';
import useStatus from 'home/useStatus';
import OpenIcon from './OpenIcon';
import OfflineIcon from './OffineIcon';
import BatteryIcon from './BatteryIcon';
import LogButton from '../log/LogButton';
import MBox from '@material-ui/core/Box';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useBoxParams } from 'home/useBoxParams';
interface Props {
  box: Box;
}

const useStyles = makeStyles((theme: Theme) => ({
  selected: {
    backgroundColor: theme.palette.grey[300] + ' !important',
  },
}));

const BoxListItem = ({ box }: Props) => {
  const classes = useStyles();
  const status = useStatus(box.id);

  const { isSelected, setBoxIdParam } = useBoxParams(box.id);

  const onItemSelected = () => setBoxIdParam();

  return (
    <ListItem
      button
      divider
      onClick={onItemSelected}
      selected={isSelected}
      classes={{ selected: classes.selected }}
    >
      <ListItemText
        primary={
          <div>
            {box.name} <OfflineIcon status={status} />
          </div>
        }
        secondary={status.updatedAtText}
      />
      <ListItemSecondaryAction>
        <MBox
          display="grid"
          gridAutoFlow="column"
          gridAutoColumns="minmax(30px, auto)"
          alignItems="center"
          justifyItems="center"
        >
          <BatteryIcon status={status} />
          <OpenIcon status={status} />
          <UnlockButton status={status} box={box} />
          <LogButton status={status} box={box} />
        </MBox>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default BoxListItem;
